import backend from "../router/backend.js";
import { axiosInstance } from "../helper/axios.js";

const state = {
  enabled: true, // VoIP Service state
  accountStatus: null, // (Idle, Unavailable)
  incomingCalls: [],

  // Phone Dial Modal
  phoneDialModal: {
    show: false,
    phoneNumber: null,
  },
};

const mutations = {
  // VoIP Service
  setVoipEnabled(state, enabled) {
    state.enabled = !!enabled;
  },

  // VoIP Account Status
  setVoipAccountStatus(state, status) {
    state.accountStatus = status ?? null;
  },

  // VoIP Incoming Calls
  setVoipIncomingCalls(state, calls) {
    state.incomingCalls = calls ?? [];
  },

  // Phone Dial Modal
  openPhoneDialModal(state, phoneNumber) {
    state.phoneDialModal = {
      show: true,
      phoneNumber: phoneNumber,
    };
  },
  closePhoneDialModal(state) {
    state.phoneDialModal = {
      show: false,
      phoneNumber: null,
    };
  },
};

const getters = {
  voipEnabled: (state) => state.enabled ?? true,
  voipAccountStatus: (state) => state.accountStatus ?? null,
  voipIncomingCalls: (state) => state.incomingCalls ?? [],
  voipRingingCalls: (state) => state.incomingCalls?.channel?.filter(call => ['Ring', 'Ringing'].includes(call.state)) ?? [],
};

const actions = {
  async fetchIncomingCalls({ commit, rootState }, extensionArg) {
    try {
      const extension = extensionArg || rootState?.auth?.userData?.user?.voip_extension;
      if (!extension) return;

      const response = await axiosInstance.get(backend.VOIP.STATUS, {
        params: { extension },
      });

      if (response?.data?.success) {
        commit('setVoipIncomingCalls', response.data.incoming_calls || []);
      }
    } catch (error) {
    }
  },
};
export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters,
};

